import { render, staticRenderFns } from "./FlowList.vue?vue&type=template&id=0a541fce"
import script from "./FlowList.vue?vue&type=script&lang=js"
export * from "./FlowList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports